export default "__VITE_ASSET__DMj_12XU__";